import { defaultHttpClient } from '../../httpClient';
import type { GetPromotionsComponentsResponse } from './types';

export const getPromotionsComponents = (
  goodsSno: number | null,
  screen: 'GOODS_DETAIL' | 'GOODS_OPTION_MODAL' | 'TODAY',
) => {
  return defaultHttpClient
    .request<GetPromotionsComponentsResponse>({
      method: 'GET',
      url: `/api/v2/promotions/components`,
      params: {
        ...(goodsSno != null && { goods_sno: goodsSno }),
        screen,
      },
    })
    .then(result => result.data);
};
